import { Message } from 'element-ui';
import Vue from "vue";
const errorHandler = {
  handleError(err, vm, info) {
    // err: Error 对象
    // vm: 抛出错误的组件实例
    // info: Vue 特定的错误信息，例如生命周期钩子
    console.error('[Global Error]', err, info);   // 开发阶段定位
    // 防止重复弹窗：同一个错误对象只提示一次
    if (err._hasBeenNotified) return;
    err._hasBeenNotified = true;

    // 友好提示
    // const msg = err.message || '系统开小差了，请稍后重试';
    // Message({
    //   message: msg,
    //   type: 'error',
    //   duration: 5000,
    //   showClose: true
    // });
  },

  handleRequestRes(res) {
    if (res.status !== 200) {
      Message({
        message: "系统错误，请稍后重试",
        type: 'error',
        duration: 5000
      });
      console.error('[Request Error]', res);
      return false;
    }
    let code = res.data.resultCode ? res.data.resultCode : res.data.code;
    if (code !== undefined && code !== 0 && code !== "0") {
      Vue.prototype.$message({
        message: res.data.message,
        type: 'error',
        duration: 5000,
      });
      console.error('[Request Error]', res);
      // 抛出错误
      res.data.code = code;
      throw res.data;
    }
    return true
  },
}

export default errorHandler;
